<template>
  <div v-if="preloader">
    <template>
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-dialog>
    </template>
  </div> 
  <div v-else>
    <v-card height="64px" width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position: fixed; z-index: 200; top: 0; width: 98%; padding-top: 16px;">
      <v-card-title class="ml-0 pl-0">
        <p class="breadcrumb-text underline-on-hover cursor" @click="$router.push('/static-assessment')">Assessments</p>
        <v-icon
          class="breadcrumb-arrow-unselected"
          style="margin-top: 6px !important"
        >mdi-chevron-right
        </v-icon>
        <p class="breadcrumb-text underline-on-hover cursor" @click="goToViewAssessment">Create Assessment</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
        <p class="breadcrumb-text">Edit Question</p>
      </v-card-title>

      <UserNavMenu/>
    </v-card>
    <div fluid class="pad px-8 background">
      <div class="d-flex align-center mb-4">
        <h3 class="mr-auto">Question</h3>
        <v-btn class="btn outline-btn mr-4" @click="goToViewAssessment" outlined rounded>Cancel</v-btn>
        <v-btn class="btn primary-btn px-6" rounded elevation="0" :disabled="enableSave"  :loading="uploadingImage" @click="updateQuestion">Save</v-btn>
      </div>

      <v-chip-group v-model="currentSelectedLanguage" class="mb-4 language-chips">
        <v-chip
          v-for="(chip, index) in availableQuesLanguages"
          :key="index"
          :value="chip"
          :class="{'active-chip': currentSelectedLanguage === chip}"                  
          outlined
          rounded
          @click="selectChip(chip)"
        >
          {{ chip }}
        </v-chip>
      </v-chip-group>
      
      <div class="py-4 bg-white">
        <v-form ref="updateForm" lazy-validation>
          <v-container fluid>
            <v-row>
                <v-col class="py-0" cols="6">
                <v-select
                  label="Question Type*"
                  outlined
                  class="rounded-lg"
                  @change="handleQuestionTypeChange"
                  v-model="questionDetails.questionType"
                  :items="questionTypeList"
                  :disabled="questionTypeList.includes('NA')"
                >
                </v-select>
              </v-col>
              <v-col class="py-0" cols="6">
                <v-text-field
                  type="text"
                  label="Language of Question*"
                  outlined
                  disabled
                  class="rounded-lg"
                  v-model="currentSelectedLanguage"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-row align="center" class="d-flex flex-row justify-space-between">
                  <v-col class="pt-0 pb-0">
                    <div class="text-body-1">Question*</div>
                  </v-col>    
                  <v-col class="pa-0">  
                    <div>
                      <v-btn text class="float-right btn outline-btn mb-2" v-if="this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionAssetUrl === 'NA'">
                        <v-icon>mdi-attachment</v-icon>
                        <span class="ml-2">Attach Image</span>
                        <input class="w-100" type="file" name="image" @change="onAttachmentChange(false)" accept="image/*, audio/*, video/*" />
                      </v-btn>                    
                      <span>
                        <v-chip text class="float-right my-2 btn outline-btn" v-if="mainImage && this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionAssetUrl !== 'NA'"
                          @click:close="closeChip" @click="openImagePreviewDialog" close>View Attachment
                        </v-chip>
                      </span>
                    </div>
                  </v-col>    
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>         
                <ckeditor :config="editorConfig" @input="saveVmodelValueInQuestionsStatement" v-model="displayQuestionsStatement" class="m-ckeditor mb-4"  @ready="onEditorReady">
                </ckeditor>                
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="6">
                <div class="text-body-1 my-2"></div>
                <v-autocomplete
  label="Marking Type*"
  :disabled="questionDetails.questionType !== 'SINGLE_CHOICE'"
  :items="filteredMarkingTypesList"
  v-model="questionDetails.markingType"
  outlined
  item-text="name"
  item-value="name"
  class="rounded-lg"
  @change="handleMarkingTypeChange"
  :rules="[
    (v) => !!v || 'Marking Type is required',
  ]"
  required
  attach
/>
              </v-col>
              <v-col class="py-0" cols="6">
                <div class="text-body-1 my-2"></div>
                <v-text-field @keypress="preventNonNumericInput"
                :disabled="questionDetails.markingType.toLowerCase() !== 'regular marking'"
                outlined class="rounded-lg" label="Correct Answer Score*"
                 v-model="questionDetails.marksAllotted">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Single Select Answers -->
            <v-row v-if="questionDetails.questionType == 'SINGLE_CHOICE'">
              <v-col>
                <div class="text-body-1 mb-2">
                  Options*
                  <span class="font-italic grey--text">(Guidelines for image in options: 1. File type -
                    .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
                  </span>
                </div>
                <v-radio-group v-model="singleSelectCorrectAnswer" :rules="questionDetails.markingType.toLowerCase() !== 'likert marking' ? [(v) => !!v || 'Please select one'] : []">
                  <v-list-item :class="singleSelectCorrectAnswer == option.optionKey
                    ? 'lightGreen rounded-xl my-2'
                    : 'grey lighten-4 rounded-xl my-2'
                    " min-height="72" v-for="(option, index) in questionOptions" :key="index">
                    <v-list-item-avatar v-if="questionDetails.markingType.toLowerCase() !== 'likert marking'">
                      <v-radio :value="option.optionKey"></v-radio>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle v-if="option.optionValue.startsWith('https://') || option.optionValue.startsWith('http://') || option.optionValue.startsWith('blob:')">
                        <span class="d-flex align-start"><img @loadstart="resolveQuestionOptionUrl"
                            :src="option.optionValue" alt="" width="auto" height="150" class="img" />
                          <v-btn icon class="ml-1"><v-icon
                              @click="restorePrevValue(index)">mdi-close</v-icon></v-btn></span>
                      </v-list-item-subtitle>
                      <v-list-item-title v-else class="align-center">
                        <div v-html="option.optionValue"></div>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row align="center" class="overflow-hidden">
                        <v-btn class="options-btn" v-if="!option.optionValue.startsWith('https://') || !option.optionValue.startsWith('http://') || !option.optionValue.startsWith('blob:')"  icon @click="editOption(index)">
                          <v-icon class="options-icon" large>mdi-format-textbox
                          </v-icon>
                        </v-btn>
                        <v-btn class="px-0 options-btn"  text color="blue"  @click="editedOptionIndex = index"
                          v-on:click="uploadingForOption = true">
                          <input class="options-attach-img" type="file" name="image" accept="image/*" @change="onChange"
                              v-on:click="uploadingForOption = true" />
                          <img :width="24" :src="uploadImageIcon" />
                        </v-btn>
                        <v-btn :disabled="questionDetails.markingType.toLowerCase() !== 'likert marking'" class="pl-0 pr-1" text color="blue" x-large  @click="openOptionScoreDialog(index)">
                          option score
                        </v-btn>
                        <v-btn icon @click="removeOption(index)">
                          <v-icon class="options-icon">mdi-delete </v-icon>
                        </v-btn>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                </v-radio-group>
              </v-col>
            </v-row>

            <!-- Multi Select Answers -->
            <v-row v-else-if="questionDetails.questionType == 'MULTIPLE_CHOICE'">
              <v-col cols="12" sm="12" md="12" class="overflow-hidden">
                <div class="text-body-1 mb-2">
                  Options*
                  <span class="font-italic grey--text">(Guidelines for image in options: 1. File type -
                    .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
                  </span>
                </div>

                <v-list-item :class="selectedAnswersForMultitpleTypeQuestions.includes(
                  option.optionKey
                )
                  ? 'lightGreen rounded-xl my-2'
                  : 'grey lighten-4 rounded-xl my-2'
                  " min-height="72" v-for="(option, index) in questionOptions" :key="index">
                  <v-list-item-avatar v-if="questionDetails.markingType.toLowerCase() !== 'likert marking'">
                    <v-checkbox v-model="selectedAnswersForMultitpleTypeQuestions"
                      :value="option.optionKey"></v-checkbox>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-subtitle v-if="option.optionValue.startsWith('https://') || option.optionValue.startsWith('http://') || option.optionValue.startsWith('blob:')">
                      <span class="d-flex align-start"><img @loadstart="resolveQuestionOptionUrl"
                          :src="option.optionValue" alt="" width="auto" height="150" class="img" />
                        <v-btn icon class="ml-1"><v-icon
                            @click="restorePrevValue(index)">mdi-close</v-icon></v-btn></span>
                    </v-list-item-subtitle>

                    <v-list-item-title v-else class="align-center">
                      <div v-html="option.optionValue"></div>
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-row align="center">
                      <v-btn  v-if="!option.optionValue.startsWith('https://') || !option.optionValue.startsWith('http://') || !option.optionValue.startsWith('blob:')"  icon @click="editOption(index)">
                        <v-icon large class="pa-2 options-icon">mdi-format-textbox
                        </v-icon>
                      </v-btn>
                      <v-btn class="px-0"  text color="blue" @click="editedOptionIndex = index"
                        v-on:click="uploadingForOption = true">
                        <input class="options-attach-img" type="file" name="image" accept="image/*" @change="onChange"
                              v-on:click="uploadingForOption = true" />
                        <img :width="24" :src="uploadImageIcon" />
                      </v-btn>
                      <v-btn icon @click="removeOption(index)">
                        <v-icon class="options-icon">mdi-delete </v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row v-if="questionDetails.questionType == 'SINGLE_CHOICE' ||
              questionDetails.questionType == 'MULTIPLE_CHOICE'
            " justify="start" align="center" class="px-2 blue--text" @click="addOption">
              <v-icon :disabled="questionOptions.length > 4" large>mdi-plus-circle-outline</v-icon>
              <v-btn :disabled="questionOptions.length > 4" class="pl-0" text x-large color="blue">Add Options</v-btn>
            </v-row>
            <v-row v-if="questionDetails.questionType == 'FILL_IN_THE_BLANKS'">
              <v-col class="py-0">
                <div class="text-body-1 my-2"></div>
                <v-textarea :rules="[
                  (v) => !!v || 'Correct Answer field is required',
                ]" required outlined class="rounded-xl" label="Correct Answer*" v-model="correctAnswer">
                </v-textarea>
              </v-col>
            </v-row>
            <!-- True False -->
            <v-row v-if="questionDetails.questionType == 'TRUE_FALSE'">
              <v-col>
                <div class="text-body-1 mb-2">Options*</div>
                <v-radio-group v-model="trueFalseCorrectAnswer" :rules="[(v) => !!v || 'Please select one']">
                  <v-list-item :class="trueFalseCorrectAnswer == option.optionKey
                    ? 'lightGreen rounded-xl my-2'
                    : 'grey lighten-4  rounded-xl my-2'
                    " min-height="72" v-for="(option, index) in [
                      { optionKey: 'A', optionValue: 'TRUE' },
                      { optionKey: 'B', optionValue: 'FALSE' },
                    ]" :key="index">
                    <v-list-item-avatar>
                      <v-radio :value="option.optionKey"></v-radio>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>{{
                        option.optionValue
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-radio-group>
              </v-col>
            </v-row>

            <!-- Match the Following -->
            <div class="text-body-1 my-4" v-if="questionDetails.questionType == 'MATCH_THE_FOLLOWING'">
                  Options*
                  <span class="font-italic grey--text">(Guidelines for image in options: 1. File type -
                    .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
                  </span>
                </div>
            <v-row v-if="questionDetails.questionType == 'MATCH_THE_FOLLOWING'">
              
                <v-col cols="6" sm="12" md="6" class="overflow-hidden">
                
                <div class="text-body-1 mb-2">
                  Match the Items*
                  
                </div>
                <v-list-item :class="selectedLhsForMtfTypeQuestions.includes(
                  option.optionKey
                )
                  ? 'lightGreen rounded-xl my-2'
                  : 'grey lighten-4 rounded-xl my-2'
                  " min-height="72" v-for="(option, index) in questionOptions" :key="index">
                  <v-list-item-avatar>
                    <v-text-field 
                    v-model="selectedLhsForMtfTypeQuestions[index]" 
                    :value="option.optionKey"
                    outlined
                    dense
                    hide-details
                    clearable
                    v-show="false"
                  ></v-text-field>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-subtitle v-if="option.optionValue.startsWith('https://') || option.optionValue.startsWith('http://') || option.optionValue.startsWith('blob:')">
                      <span class="d-flex align-start"><img @loadstart="resolveQuestionOptionUrl"
                          :src="option.optionValue" alt="" width="auto" height="150" class="img" />
                        <v-btn icon class="ml-1"><v-icon
                            @click="restorePrevValue(index)">mdi-close</v-icon></v-btn></span>
                    </v-list-item-subtitle>

                    <v-list-item-title v-else class="align-center">
                      <div v-html="option.optionValue"></div>
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-row align="center">
                      <v-btn  v-if="!option.optionValue.startsWith('https://') || !option.optionValue.startsWith('http://') || !option.optionValue.startsWith('blob:')"  icon @click="editOption(index)">
                        <v-icon large class="pa-2">mdi-format-textbox
                        </v-icon>
                      </v-btn>
                      <v-btn class="px-0"  text color="blue" @click="editedOptionIndex = index"
                        v-on:click="uploadingForOption = true">
                        <img :width="24" :src="uploadImageIcon" />
                      </v-btn>
                      <v-btn icon @click="removeOption(index)">
                        <v-icon>mdi-delete </v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
              <v-col cols="6" sm="12" md="6" class="overflow-hidden">
                <div class="text-body-1 mb-2">
                  Correct Answers*
                  
                </div>

                <v-list-item :class="selectedRhsForMtfTypeQuestions.includes(
                  ans.optionKey
                )
                  ? 'lightGreen rounded-xl my-2'
                  : 'grey lighten-4 rounded-xl my-2'
                  " min-height="72" v-for="(ans, index) in answers" :key="index">
                  <v-list-item-avatar>
                    <v-text-field 
                    v-model="selectedRhsForMtfTypeQuestions[index]" 
                    :value="ans.optionKey"
                    outlined
                    dense
                    hide-details
                    clearable
                    v-show="false"
                  ></v-text-field>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-subtitle v-if="ans.optionValue.startsWith('https://') || ans.optionValue.startsWith('http://') || ans.optionValue.startsWith('blob:')">
                      <span class="d-flex align-start"><img @loadstart="resolveQuestionOptionUrl"
                          :src="ans.optionValue" alt="" width="auto" height="150" class="img" />
                        <v-btn icon class="ml-1"><v-icon
                            @click="restorePrevValue(index)">mdi-close</v-icon></v-btn></span>
                    </v-list-item-subtitle>

                    <v-list-item-title v-else class="align-center">
                      <div v-html="ans.optionValue"></div>
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-row align="center">
                      <v-btn  v-if="!ans.optionValue.startsWith('https://') || !ans.optionValue.startsWith('http://') || !ans.optionValue.startsWith('blob:')"  icon @click="editAnswer(index)">
                        <v-icon large class="pa-2">mdi-format-textbox
                        </v-icon>
                      </v-btn>
                      <v-btn class="px-0" text color="blue" @click="editedAnswerIndex = index"
                        v-on:click="uploadingForOption = true">
                        <img :width="24" :src="uploadImageIcon" />
                      </v-btn>
                      <v-btn icon @click="removeOption(index)">
                        <v-icon>mdi-delete </v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
            </v-row>
            <!-- Fill in the blanks -->
            <v-row v-if="questionDetails.questionType == 'Fill in the blanks'">
              <v-col class="py-0">
                <div class="text-body-1 my-2">Answer*</div>
                <v-textarea outlined class="rounded-xl" label="Enter Answer">
                </v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0">
                <label class="d-block mb-2">Answer Explanation*</label>
                <ckeditor :config="editorConfigForOption" v-model="displayAnswerExplanation" class="m-ckeditor mb-8">
                </ckeditor>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col class="py-0">
                <label class="d-block mb-2">Hint</label>
                <textarea class="rounded-lg mb-4 pa-4" v-model="getQuestionHint"></textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0">
                <v-text-field
                type="text"
                label="Question ID"
                outlined disabled
                class="rounded-lg"
                v-model="questionDetails.questionId"
                >
                </v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-autocomplete
                  v-model="questionDetails.application"
                  label="Application*"
                  :items="productOptions"
                  outlined
                  class="rounded-lg"
                  required
                  :rules="[(v) => !!v || 'Application is required']"
                  attach
                  disabled
                ></v-autocomplete>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                label="Skills*"
                outlined
                class="rounded-lg"
                v-model="questionDetails.skill"
                :rules="[v => !!v || 'Skill is required']"
                :items="skillsList"
                 item-text="name"
                item-value="name"
                item-disabled="disabled"
                disabled
                >
                </v-select>
              </v-col>
              <v-col class="py-0">
                <v-autocomplete :disabled="questionDetails.skill !== 'Psychometry'" label="Set Number*" :items="setNumbersList" outlined
                  class="rounded-lg" v-model="questionDetails.setNumber" required :rules="questionDetails.skill === 'Psychometry' ? [(v) => !!v || 'Set Number is required'] : []" attach>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                :label="questionDetails.skill !== 'Psychometry'? 'Subject*' :'Subject'"
                :rules="questionDetails.skill.toLowerCase() !== 'psychometry' ? [(v) => !!v || 'Please enter a valid Subject'] : []"
                outlined
                class="rounded-lg"
                v-model="getQuestionSubject"
                :disabled="subjectsList.includes('NA')"
                :items="subjectsList"
                >
                </v-select>
              </v-col>
              <v-col 
              class="py-0" cols="6">
                <v-select
                label="NEP Level*"
                outlined disabled
                class="rounded-lg"
                v-model="questionDetails.level"
                @change="onLevelChange"
                :items="levelsList"
                item-disabled="disabled"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                label="Grade*"
                outlined disabled
                class="rounded-lg"
                v-model="questionDetails.grade"
                :items="gradesList"
                item-disabled="disabled"
                >
                </v-select>
              </v-col>
              <v-col class="py-0" cols="6">
                <v-text-field
                type="text"
                :label="questionDetails.skill === 'Psychometry'? 'Strand*' :'Strand'"
                outlined
                class="rounded-lg"
                :rules="questionDetails.skill === 'Psychometry' ? [(v) => !!v || 'Please enter a valid Strand'] : []"
                v-model="getQuestionStrand"
                disabled
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-text-field
                  type="text"
                  label="Sub-Strand"
                  outlined
                  class="rounded-lg"
                  v-model="getQuestionSubStrand"
                >
                </v-text-field>
              </v-col>
              <v-col class="py-0" cols="6">
                <v-text-field
                type="text"
                label="Topic*"
                outlined
                :rules="[v=>!!v || 'Topic is required']"
                class="rounded-lg"
                v-model="getQuestionTopic"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0">
                <v-select
                label="Select or search Lo"
                outlined
                class="rounded-lg"
                :disabled="questionDetails.skill.includes('Psychometry')"
                >
                </v-select>
              </v-col>
              <v-col class="py-0">
                <v-autocomplete
                  v-model="questionDetails.hrisUniqueRole"
                  label="HRIS Roles"
                  :items="hrisUniqueRole"
                  outlined
                  class="rounded-lg"
                  attach
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0">
                <v-autocomplete
                  label="Case Sensitive"
                  :items="['Yes', 'No', ...(questionDetails.isCaseSensitive == 'NA'? ['NA']: [])]"
                  outlined
                  class="rounded-lg"
                  required
                  v-model="questionDetails.isCaseSensitive"
                  :disabled="questionDetails.isCaseSensitive === 'NA'"
                  attach
                ></v-autocomplete>
              </v-col>
              <v-col class="py-0" cols="6">
                <v-select
                label="Blooms Taxonomy"
                outlined
                class="rounded-lg"
                v-model="questionDetails.bloomsTaxonomy"
                :disabled="bloomsTaxonomyList.includes('NA')"
                :items="bloomsTaxonomyList"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                label="Choose Difficulty Level*"
                outlined
                class="rounded-lg"
                v-model="questionDetails.difficultyLevel"
                :rules="[v=>!!v ||'Difficulty Level is required']"
                :disabled="difficultyLevelsList.includes('NA')"
                :items="difficultyLevelsList"
                >
                </v-select>
              </v-col>
              <v-col class="py-0">
                <v-select
                label="Choose Complexity Level"
                outlined
                class="rounded-lg"
                v-model="questionDetails.complexityLevel"
                :disabled="complexityLevelsList.includes('NA')"
                :items="complexityLevelsList"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                label="Proficiency Level"
                outlined
                v-model="questionDetails.proficiencyLevel"
                :disabled="proficiencyLevelList.includes('NA')"
                class="rounded-lg"
                :items="proficiencyLevelList"
                >
                </v-select>
              </v-col>
              <v-col class="py-0" cols="6">
                <v-select
                label="Group Name*"
                outlined
                v-model="questionDetails.groupName"
                class="rounded-lg"
                :items="groupNames"
                disabled
                >
                </v-select>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col class="py-0">
                <div class="text-body-1 my-2"></div>
                <v-select

  label="Authored By"
  :items="authoredByOptions"
  v-model="questionDetails.authoredBy"
  outlined
  class="rounded-lg"
  
/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </div>

          <!-- Edit Option Dialog -->
    <v-dialog max-width="887px" v-model="optionTextFieldDialog" center>
      <v-card>
        <v-card-title class="secondary mb-8">Edit Option</v-card-title>
        <v-card-text>
          <ckeditor :config="editorConfigForOption" v-model="editedCkeditorValue" class="m-ckeditor"  @ready="onEditorReady"></ckeditor>
          <p v-if="!isValid" class="error-message red--text">Please enter a valid value (maximum 200 characters).</p>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn depressed rounded class="btn outline-btn pa-4"
            @click="optionTextFieldDialog = false">Cancel</v-btn>
          <v-btn depressed rounded @click="saveEditedValue" class="btn primary-btn pa-4" :disabled="!isValid">Save</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>

      <!-- Edit Answer Dialog -->
      <v-dialog max-width="887px" v-model="answerTextFieldDialog" center>
        <v-card>
          <v-card-title class="gray-02 mb-8">Edit Option</v-card-title>
          <v-card-text>
            <!-- <v-text-field
            outlined
            class="rounded-xl"
            v-model="editedOption.value"
            label="Enter Option*"
          ></v-text-field> -->
            <ckeditor :config="editorConfigForOption" v-model="editedCkeditorValue" class="m-ckeditor"  @ready="onEditorReady"></ckeditor>
            <p v-if="!isValid" class="error-message red--text">Please enter a valid value (maximum 200 characters).</p>
          </v-card-text>
          <v-card-actions class="px-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn depressed rounded class="btn outline-btn font-weight-medium pa-4"
              @click="answerTextFieldDialog = false">Cancel</v-btn>
            <v-btn depressed rounded @click="saveEditedAnswer" class="btn primary-btn pa-4" :disabled="!isValid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Option Score Dialog -->
      <v-dialog max-width="438px" class="options-score-dialog" v-model="optionScoreDialog">
        <v-card class="d-flex flex-column pa-3 gap-4"> 
          <div class="font-weight-bold h6">
            Score
          </div>
          <v-text-field
            v-model="optionScoreInput"
            type="number"
            outlined
            min="0"
            class="rounded-xl"
            placeholder="Enter Option Score here"
            label="Option Score*"
            required
            :rules="questionDetails.markingType === 'Likert Marking' ? [(v) => !!v || 'Option Score is required'] : []">
          </v-text-field>
          <div class="d-flex justify-end w-100 gap-4">
            <v-btn class="btn outline-btn elevation-0" @click="closeOptionScoreDialog">
              Cancel
            </v-btn>
            <v-btn class="btn primary-btn" @click="saveOptionScore">
              Save
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="updateQuestionDialog" class="cdz" max-width="400px" min-height="294px" persistent>
                  <v-card>
                    <v-container fluid class="pa-2">
                      
                      <v-card-text class="text-center d-flex flex-column align-center" >
                        <img src="../assets/done.svg">
                        <p class="text-h5 text-center py-4">Questions Updated Successfully</p>
                        
                        <v-btn class="btn primary-btn w-100" large  @click="saveQuestionDetail" rounded>Ok</v-btn>
                      </v-card-text>
                    </v-container>
                  </v-card>
      </v-dialog>

      <template>
      <div v-if="imagePreview">
        <v-dialog v-model="imagePreview">
          <v-card>
            <div class="d-flex justify-center align-center flex-column">
              <v-img :src="questionAssetUrlForPreview"
                     :alt="`Image preview of ${questionAssetUrlForPreview}`" 
                     class="img pa-0 w-auto h-auto" />
            </div>
            <div class="d-flex justify-end pb-2">
              <v-btn class="btn outline-btn font-weight-medium mx-3 text-right" rounded
                @click="closeDialog">
                Cancel
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </template>



  </div>
</template>

<script>

    import AuthService from "../services/AuthService";
    import StaticAssessmentController from "@/controllers/StaticAssessmentController";
    import LevelController from "@/controllers/LevelController";
    import GradeController from "@/controllers/GradeController";
    import SkillsController from "@/controllers/SkillsController";
    import QuestionsController from "../controllers/QuestionsController";
    import AudienceRoleController from "@/controllers/AudienceRoleController";
    import AudienceRolesController from "@/controllers/AudienceRolesController";
    import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";
    import { storage } from "../firebase";
    import { mapGetters } from "vuex";
    import { cloneDeep } from "lodash";
    import UserNavMenu from "@/components/UserNavMenu.vue";

    const IMAGE_ALT_SRC = '../assets/caution.png'

    const defaultOptions = [
      {
        optionKey: "A",
        optionValue: "Option 1",
        optionScore: 0,
      },
      {
        optionKey: "B",
        optionValue: "Option 2",
        optionScore: 0,
      },
      {
        optionKey: "C",
        optionValue: "Option 3",
        optionScore: 0,
      },
      {
        optionKey: "D",
        optionValue: "Option 4",
        optionScore: 0,
      },
    ];
    const defaultAnswers = [
      {
        optionKey: "A",
        optionValue: "Answer 1",
      },
      {
        optionKey: "B",
        optionValue: "Answer 2",
      },
      {
        optionKey: "C",
        optionValue: "Answer 3",
      },
      {
        optionKey: "D",
        optionValue: "Answer 4",
      },
    ];

    export default {
      components:{
         UserNavMenu
      },
        name: "EditStaticAssessment",
        data() {
            return {
                fileInputRefs:[],
                preloader: true,
                selectedChip: null,
                chips: ['English', 'Hindi', 'Marathi'],
                assessmentId: "",
                questionId: "",
                questionDetails: {},
                gradesData: [],
                levelsList: [],
                allLevels: [],
                gradesList: [],
                skillsData: [],
                skillsList:[],
                hrisUniqueRole: [],
                questionTypeList: [
                  "SINGLE_CHOICE",
                  "MULTIPLE_CHOICE",
                  // "FILL_IN_THE_BLANKS",
                  "TRUE_FALSE",
                  "MATCH_THE_FOLLOWING",
                ],
                productOptions: ["MESTA", "SRS", "Hubble STAR", "LMS"],
                markingTypesList: [
                  "Regular Marking",
                  "Likert Marking"
                ],
                setNumbersList: ["1","2","3"],
                subjectsList: ['English', 'Mathematics', 'Science', 'Logical Reasoning'],
                groupNames: [],
                authoredByOptions: ['HubbleHox', 'Vendor Acquired', 'Acquired from Publications', 'Acquired From Book', 'Practice guide', 'Vertex', 'Ampersand'],
                currentSelectedLanguage: null,
                availableQuesLanguages: [],
                complexityLevels: ["P1", "P2", "P3", "P4", "P5"],
                difficultyLevels: ["EASY", "MEDIUM", "HARD", "VERY_HARD"],
                bloomsTaxonomyList: [
                  "REMEMBER",
                  "UNDERSTAND",
                  "APPLY",
                  "ANALYZE",
                  "EVALUATE",
                  "CREATE",
                ],
                options: [...defaultOptions],
                answers: [...defaultAnswers],
                editedOptionIndex: 0,
                optionTextFieldDialog: false,
                answerTextFieldDialog:false,
                editedCkeditorValue: "",
                editorConfig: {
                  extraPlugins: "ckeditor_wiris",
                },
                editorConfigForOption: {
                  extraPlugins: "ckeditor_wiris",
                },
                proficiencyLevelList: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'],
                imagePreview: false,
                mainImage: true,
                selectedFile: null,
                tempOptions: new Map(),
                questionAssetUrl: "",
                uploadingForOption: false,
                uploadingMsg: "File Uploading...",
                questionAssetUrlForPreview: IMAGE_ALT_SRC,
                selectedAnswers: [],
                displayQuestionsStatement:"",
                displayAnswerExplanation: "",
                uploadingImage: false,
                fieldOptionsMap: {
                  'subject': 'subjectsList',
                  'level':'levelsList',
                  'skill': 'skillsList',
                  'grade': 'gradeList',
                  'questionType': 'questionTypeList',
                  'bloomsTaxonomy': 'bloomsTaxonomyList',
                  'difficultyLevel': 'difficultyLevelsList',
                  'complexityLevel': 'complexityLevelsList',
                  'proficiencyLevel': 'proficiencyLevelList',

                },
                singleSelectCorrectAnswer: null,
                selectedAnswersForMultitpleTypeQuestions: [],
                trueFalseCorrectAnswer: null,
                selectedLhsForMtfTypeQuestions:[],
                selectedRhsForMtfTypeQuestions:[],
                uploadImageIcon: require("@/assets/uploadImage.svg"),
                optionScoreDialog: false,
                selectedOptionIndex: 0,
                optionScoreInput: 0,
                updateQuestionDialog:false,
            }
        },
        async created() {
          this.$store.state.breadcrumb = "Assessment";
          this.questionId = this.$route.query.questionId;
          if(Object.keys(this.questionForEdit).length > 0){
            this.questionDetails = cloneDeep(this.questionForEdit);
            if(this.questionDetails && this.questionDetails.QuestionDetails) {
              this.availableQuesLanguages = Object.keys(this.questionDetails.QuestionDetails).map(key => key.charAt(0).toUpperCase() + key.slice(1))
              this.currentSelectedLanguage = this.availableQuesLanguages[0];
              this.singleSelectCorrectAnswer = this.questionDetails.correctAnswer;
              this.selectedAnswersForMultitpleTypeQuestions = this.checkArrOptions(this.questionDetails.correctAnswer);
              this.trueFalseCorrectAnswer = this.questionDetails.correctAnswer;
              if(this.questionDetails.questionType == 'MATCH_THE_FOLLOWING'){
                this.formatOptionAndAnswer(this.questionDetails.correctAnswer)
              }
            }
            this.disableNotApplicableFields()
            this.preloader=false;
            
          }
          this.getLevels();
          // this.getGradesMappedToLevels();
          if(this.questionDetails.hrisUniqueRole !== 'NA')this.getAudienceRoles();
          else this.hrisUniqueRole = ['NA'];
          this.getSkills();
          await this.getAudienceRoleGroups();
        },
        mounted() {
           setTimeout(()=>{
            if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                this.displayQuestionsStatement = this.questionDetails.QuestionDetails[languageKey]?.questionStatement || '';
                this.displayAnswerExplanation = this.questionDetails.QuestionDetails[languageKey]?.answerExplanation || '';
                // return this.questionDetails.QuestionDetails[languageKey]?.questionStatement || '';
              }else{
                this.displayQuestionsStatement = '';
              }
             
          },1000)
          
           this.questionDetails.authoredBy =  'HubbleHox';
        },
        watch: {
          imagePreview(newValue) {
            if (newValue) {
              this.resolveQuestionAssetUrl(); // Call the function when the dialog opens
            }
          },
          questionDetails: {
            handler(val) {
              if (this.questionDetails.questionType == 'MULTIPLE_CHOICE') {
                // Ensure correctAnswer is an array, split if it's a comma-separated string
                if (typeof val.correctAnswer === 'string') {
                  this.selectedAnswers = val.correctAnswer.split(',');
                } else {
                  this.selectedAnswers = Array.isArray(val.correctAnswer)
                    ? val.correctAnswer
                    : [val.correctAnswer];
                }
              }
            },
            immediate: true,
            deep: true
          }
        },
        methods: {
            disableNotApplicableFields(){
              Object.entries(this.questionDetails).forEach(([key, value])=>{
                const isFieldNotApplicable = Array.isArray(value) ? (value?.includes('NA')) : (value === 'NA');
                if(isFieldNotApplicable){
                  const dropdownList = this.fieldOptionsMap[key];
                  this[dropdownList] = ['NA'];
                }
              })
            },
            async getAudienceRoleGroups(){
              const response = await AudienceRolesController.getAudienceRoleGroups();
              if(response.status==200){
                this.groupNames = response.data.audienceRoleGroup.map(({name}) => name);
              }
            },
            logout() {
                AuthService.logout();
                this.$router.push("/login");
            },
            updateCorrectAnswer() {
              this.questionDetails.correctAnswer = [...this.selectedAnswers].toString();
            },
            async fetchAssessmentQuestionById(assessmentId) {
                this.isLoading = true;
                const response = await StaticAssessmentController.getStaticAssessmentsById(assessmentId, this.pageSize, this.page);
                if(response.status == 200) {
                    const questionsList = response.data.assessments?.[0]?.questions;
                    this.questionDetails = questionsList.find(question => question.questionId == this.questionId);
                    if(this.questionDetails && this.questionDetails.QuestionDetails) {
                      this.availableQuesLanguages = Object.keys(this.questionDetails.QuestionDetails).map(key => key.charAt(0).toUpperCase() + key.slice(1))
                      this.currentSelectedLanguage = this.availableQuesLanguages[0];
                    }
                    this.preloader = false;
                    this.isLoading = false;
                } else {
                    this.preloader = false;
                    this.isLoading = false;
                }
            },
            goToViewAssessment() {
              this.$store.dispatch('setQuestionForEdit', {});
              this.$router.push({ path: "/update-static-assessment", query: {e1:2 }});
            },
            async getLevels() {
              const response = await LevelController.getLevel();
              if (response.status == 200) {
                if (response.data.levels.length > 0) {
                  this.allLevels = response.data.levels;
                  this.levelsList = this.allLevels.map(level => level.name);
                  
                  this.getGradesMappedToLevels("",true)
                } else {
                  this.levelsList = [];
                  this.allLevels = [];
                }
              }
            },
            async getGrades() {
              const response = await GradeController.getAllGrades();
              if (response.status == 200) {
                this.gradesData = response.data.grades;
                this.gradesList = this.gradesData.map(grade => grade.name);
              } else {
                alert("Levels Not Found!!");
              }
            },
            getGradesMappedToLevels(event, isRehydratingForm=false){
              if(!isRehydratingForm){
                this.gradesList = [];
                this.questionDetails.grades = [];
              }
              this.allLevels.forEach(level=>{
              if(this.questionDetails.level == level.name){
                this.gradesList.push(...level.grades)
              }
              })
            },
            async getSkills() {
              const response = await SkillsController.getSkills();
              if (response.status) {
                if (response.data.skills.length > 0) {
                  this.skillsData = response.data.skills;
                  this.skillsList = this.skillsData.map(({name}) => ({name: name, disabled: name !== "Psychometry"}));
                } else {
                  this.skillsData = [];
                  this.skillsList = [];
                }
              } else {
                alert(response.data.error);
              }

            },
            onLevelChange () {
              this.gradesList = [];
              this.questionDetails.grade = '';
              // this.questionDetails.level = "";
              this.getGradesMappedToLevels("",true)
            },
            selectChip(chip) {
              if(chip) {
                this.saveVmodelValueInQuestionsStatement()
                this.currentSelectedLanguage = chip;
                if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                this.displayQuestionsStatement = this.questionDetails.QuestionDetails[languageKey]?.questionStatement || ''
                // return this.questionDetails.QuestionDetails[languageKey]?.questionStatement || '';
              }else{
                this.displayQuestionsStatement = '';
              }
              }
            },
            saveVmodelValueInQuestionsStatement(){
                const languageKey = this.currentSelectedLanguage.toLowerCase();
               this.questionDetails.QuestionDetails[languageKey].questionStatement =  this.displayQuestionsStatement
            },
            updateQuestion(){
               this.updateQuestionDialog = true;
            },
            saveQuestionDetail() {
              if(this.$refs.updateForm.validate()){
                if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                  const languageKey = this.currentSelectedLanguage.toLowerCase();
                  if (this.questionDetails.QuestionDetails[languageKey]) {
                    // Update the value of questionStatement and answerExplanation dynamically
                    this.questionDetails.QuestionDetails[languageKey].questionStatement = this.displayQuestionsStatement;
                    let correctAnswer = null;
                    if (this.questionDetails.questionType == "MATCH_THE_FOLLOWING") {
                        correctAnswer = this.getOptions();
                        this.questionDetails.mtfOptions = this.prepareOptions(correctAnswer);
                      } else {
                        correctAnswer = this.getCorrectAnswer();
                      }
                    this.questionOptions = this.getOptions();
                    this.questionDetails.correctAnswer = correctAnswer;
                    this.questionDetails.QuestionDetails[languageKey].answerExplanation = this.displayAnswerExplanation;
                  }
                }
                this.questionDetails.isEdited = true;
                this.$store.dispatch('setQuestionForEdit', this.questionDetails);
                // Update the specific question in staticAssessmentData.questions
                const questionIndex = this.staticAssessmentData.questions.findIndex(question => question.questionId === this.questionId);
                if (questionIndex !== -1) {
                    this.staticAssessmentData.questions[questionIndex] = this.questionDetails; // Update with latest questionDetails
                }
                // Update the specific question in staticAssessmentData.questionsToUpload
                const uploadQuestionIndex = this.staticAssessmentData.questionsToUpload.findIndex(question => question.questionId === this.questionId);
                if (uploadQuestionIndex !== -1) {
                    this.staticAssessmentData.questionsToUpload[uploadQuestionIndex] = this.questionDetails; // Update with latest questionDetails
                }
                //stashing staticAssessmentData and QuestionForEdit in vuex store
                this.$store.dispatch('setAssessmentData', this.staticAssessmentData);
                let pageQuery = {}
                this.updateQuestionDialog = false;
                if(this.$route.query.hasOwnProperty('tablePageSize')){
                  pageQuery['tablePageSize'] = this.$route.query.tablePageSize
                }
                this.$router.push({ path: "/update-static-assessment", query: {e1:2, ...pageQuery}});
              }
            },
            removeOption(index) {
              let updatedOptions = this.questionOptions.filter((_, i) => i !== index);
              updatedOptions = updatedOptions.map((option, i) => ({
                ...option,
                optionKey: String.fromCharCode('A'.charCodeAt(0) + i),
              }));
                this.questionOptions = updatedOptions; // Trigger setter
            },
            removeImageOption(option){
              option.optionValue = '';
            },
            addOption() {
              const keys = this.questionOptions.map(option => option.optionKey);
              const nextKey = String.fromCharCode(
                keys.length > 0 ? Math.max(...keys.map(key => key.charCodeAt(0))) + 1 : 'A'.charCodeAt(0)
              );
              const newOption = {
                optionValue: '',
                optionKey: nextKey,
                isSelected: false
              };
              const updatedOptions = [...this.questionOptions, newOption];
              this.questionOptions = updatedOptions;
              // console.log(this.options);
            },
            getAlphabet(num) {
              // ASCII value for 'A' is 65
              // The alphabet letter corresponding to num can be calculated by adding num to 65 and then getting the character using fromCharCode()
              return String.fromCharCode(65 + num);
            },
            editOption(index) {
              this.editedOptionIndex = index;
              this.optionTextFieldDialog = true;
              this.editedCkeditorValue = ''
              setTimeout(() => {
                this.editedCkeditorValue = this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionOptions[this.editedOptionIndex].optionValue;

                // This code will execute after a 1 second delay
                //this.options[this.editedOptionIndex] = this.options[index];
              }, 1000);
            },
            editAnswer(index) {
              this.editedAnswerIndex = index;
              this.answerTextFieldDialog = true;
              setTimeout(() => {
                this.editedCkeditorValue =
                  this.answers[this.editedAnswerIndex].optionValue;

                // This code will execute after a 1 second delay
                //this.options[this.editedOptionIndex] = this.options[index];
              }, 1000);
            },
            onEditorReady(editor) {
              editor.on("afterCommandExec", function(event) {
                var commandName = event.data.name;
                if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
                  setTimeout(() => {
                      const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
                      wiris_license_overlays.forEach(element => {
                        element.remove();
                      });
                    }, 2000)
                }
              });
            },
            saveEditedValue() {
              if (this.questionDetails && this.questionDetails.QuestionDetails && this.currentSelectedLanguage) {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                
                if (!this.questionDetails.QuestionDetails[languageKey].questionOptions) {
                  this.questionDetails.QuestionDetails[languageKey].questionOptions = [];
                }

                if (this.questionDetails.QuestionDetails[languageKey].questionOptions[this.editedOptionIndex]) {
                  this.questionDetails.QuestionDetails[languageKey].questionOptions[this.editedOptionIndex].optionValue = this.editedCkeditorValue;
                }

                this.optionTextFieldDialog = false;
              }
            },
            getTextWithoutHTMLTags(text) {
              return text.replace(/<[^>]*>?/gm, '');
            },
            onAttachmentChange(isOption, index = null) {
              const file = event.target.files[0];
              if (!file) return;

              this.selectedFile = file;
              this.uploadingMsg = "File Uploading...";
              this.uploadingForOption = isOption;
              this.editedOptionIndex = index;

              // Trigger the upload
              this.uploadAsset();
            },
            onChange(e) {
              this.tempOptions.set(this.editedOptionIndex, this.questionOptions[this.editedOptionIndex].optionValue)
              this.selectedFile = e.target.files[0];
              this.uploadingMsg = "File Uploading...";
              this.uploadingDialog = true;
              this.uploadAsset();
            },
            uploadAsset() {
              this.uploadingImage = true;
              if (this.uploadingForOption && this.editedOptionIndex !== null) {
                this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionOptions[this.editedOptionIndex].resolvedOptionUrl = new URL(`../assets/loading.gif`, import.meta.url).href;
              } else {
                this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].resolvedQuestionAssetUrl = new URL(`../assets/loading.gif`, import.meta.url).href;
              }
              if (this.selectedFile != null) {
                const storageRef = ref(
                  storage,
                  "/question_bank/" + this.selectedFile.name + "_" + new Date().getTime()
                );
                uploadBytes(storageRef, this.selectedFile).then((snapshot) => {
                  getDownloadURL(snapshot.ref).then((url) => {
                    if (this.uploadingForOption && this.editedOptionIndex !== null) {
                      // Upload for an option
                      this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionOptions[
                        this.editedOptionIndex
                      ].optionValue = url; // Store URL as optionValue
                      this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionOptions[
                        this.editedOptionIndex
                      ].resolvedOptionUrl = url; //overwrite resolved assetURL
                    } else {
                      // Upload for main question image
                      this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionAssetUrl = url;
                      this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].resolvedQuestionAssetUrl = url;
                      this.mainImage = true;
                    }
                    this.uploadingForOption = false;
                    this.uploadingMsg = "File uploaded successfully";
                    this.uploadingImage = false;
                  });
                });
              }
            },
            openImagePreviewDialog() {
              this.imagePreview = true
            },
            closeChip() {
              this.questionDetails.QuestionDetails[this.currentSelectedLanguage.toLowerCase()].questionAssetUrl = 'NA';
              this.mainImage = false;
            },
            resolveQuestionOptionUrl: async function (url) {
              const languageKey = this.currentSelectedLanguage.toLowerCase();
              const options = this.questionDetails.QuestionDetails[languageKey]?.questionOptions;
              
              const optionIndex = options?.findIndex(({ optionValue }) => optionValue === url);
              if (optionIndex !== -1 && url.startsWith('https://drive.google.com/')) {
                let fileId = null;
                this.questionDetails.QuestionDetails[languageKey].questionOptions[optionIndex].optionValue = new URL(`../assets/loading.gif`, import.meta.url).href
                if (url.indexOf('&id=') > -1) {
                  fileId = url.split('&id=').pop();
                } else {
                  const pattern = /\/file\/d\/([^\\/]+)\//;
                  fileId = url.match(pattern)[1];
                }

                const response = await QuestionsController.doFetchFileContentFromDriveUrl(fileId);
                if(response.status == 200) { 
                  this.questionDetails.QuestionDetails[languageKey].questionOptions[optionIndex].optionValue = window.URL.createObjectURL(new Blob([response.data]));
                } else {
                  this.questionDetails.QuestionDetails[languageKey].questionOptions[optionIndex].optionValue = new URL(`../assets/caution.png`, import.meta.url).href;
                }
              }
            },
            restorePrevValue(index) {
              const languageKey = this.currentSelectedLanguage.toLowerCase();
              const options = this.questionDetails.QuestionDetails[languageKey]?.questionOptions;

              if (this.tempOptions.has(index) && options) {
                options[index].optionValue = this.tempOptions.get(index);
              }
            },
            resolveQuestionAssetUrl: async function () {
              const languageKey = this.currentSelectedLanguage?.toLowerCase();
              const url = this.questionDetails?.QuestionDetails[languageKey]?.resolvedQuestionAssetUrl || this.questionDetails?.QuestionDetails[languageKey]?.questionAssetUrl || IMAGE_ALT_SRC;

              if (this.questionAssetUrlForPreview === IMAGE_ALT_SRC) {
                if (url.startsWith('https://drive.google.com/')) {
                  let fileId = null;
                  if (url.indexOf('&id=') > -1) {
                    fileId = url.split('&id=').pop();
                  } else {
                    // Regular expression pattern to extract file ID
                    const pattern = /\/file\/d\/([^\\/]+)\//;
                    fileId = url.match(pattern)[1];
                  }

                  try {
                    const response = await QuestionsController.doFetchFileContentFromDriveUrl(fileId);
                    if (response.status === '500') {
                      this.questionAssetUrlForPreview = IMAGE_ALT_SRC;
                    } else {
                      this.questionAssetUrlForPreview = window.URL.createObjectURL(new Blob([response.data]));
                    }
                  } catch (err) {
                    this.questionAssetUrlForPreview = IMAGE_ALT_SRC;
                    alert("Error occurred while fetching the file: " + err);
                    console.error('Error occurred ', err);
                  }
                } else if (url !== this.questionAssetUrlForPreview) {
                  this.questionAssetUrlForPreview = url;
                }
              }
            },
            closeDialog() {
              this.imagePreview = false;
              this.questionAssetUrlForPreview = IMAGE_ALT_SRC; // Reset or set to a default image
            },
            openDialog() {
              this.imagePreview = true;
              this.resolveQuestionAssetUrl(); // Call the method when opening the dialog
            },
            selectFile(index) {
              this.editedOptionIndex = index
              this.uploadingForOption = true
              const fileInput = this.fileInputRefs[index];

              if (fileInput) {
                fileInput.click();
              } else {
                console.error(`Ref ${refName} not found`);
              }
            },
            async getAudienceRoles() {
              const response = await AudienceRoleController.getAudienceRoles();
              this.hrisUniqueRole = response.data.audienceRoles.map(role => role.HRIS_unique_role);
            },
            openOptionScoreDialog(index){
              this.optionScoreDialog = true;
              this.selectedOptionIndex = index;
              this.optionScoreInput = this.questionOptions[index].optionScore;
            },
            saveOptionScore(){
              this.questionOptions[this.selectedOptionIndex].optionScore = this.optionScoreInput;
              this.closeOptionScoreDialog();
            },
            closeOptionScoreDialog(){
              this.optionScoreDialog = false;
            },
            handleQuestionTypeChange() {
              if (this.questionDetails.questionType !== 'SINGLE_CHOICE') {
                this.questionDetails.markingType = 'Regular Marking';
              }
                this.handleMarkingTypeChange();
            },
            handleMarkingTypeChange(){
              this.questionOptions = this.questionOptions.map(({optionScore, ...rest})=> ({...rest, optionScore: 0}));
              this.questionDetails.marksAllotted = 0;
            },
            saveEditedAnswer() {
              this.answers[this.editedAnswerIndex].optionValue =
                this.editedCkeditorValue;
              this.answerTextFieldDialog = false;
            },
            preventNonNumericInput(event) {
              const charCode = event.keyCode || event.which;
              const charStr = String.fromCharCode(charCode);

              // Prevent entering "." or any non-numeric characters
              if (!/^[1-9]+$/.test(charStr)) {
                event.preventDefault();
              }
            },
            getOptions() {
              switch (this.questionDetails.questionType) {
                case "SINGLE_CHOICE":
                  return this.questionOptions;

                case "MULTIPLE_CHOICE":
                  return this.questionOptions;

                case "FILL_IN_THE_BLANKS":
                  return [];

                case "TRUE_FALSE":
                  return [
                    {
                      optionKey: "A",
                      optionValue: "TRUE",
                    },
                    {
                      optionKey: "B",
                      optionValue: "FALSE",
                    },
                  ];

                case "MATCH_THE_FOLLOWING":
                  
                    const result = this.questionOptions.map(option => {
                    const answer = this.answers.find(a => a.optionKey === option.optionKey);
                    const col1 = option.optionValue.replace(/<\/?p>/g, '').trim(); // Remove HTML tags
                    const col2 = answer.optionValue.replace(/<\/?p>/g, '').trim(); // Remove HTML tags
                    return `${col1}:${col2}`;
                  }).join(', ');
                  return result

                default:
                  break;
              }
            },
            prepareOptions(correctAnswer) {
              const mtfOptions = [];
              const entries = correctAnswer.split(', ');

              // Extract all countries and cities into arrays
              const countries = entries.map(entry => entry.split(':')[0]);
              const cities = entries.map(entry => entry.split(':')[1]);

              // Shuffle the cities array
              const shuffledCities = cities.sort(() => Math.random() - 0.5);

              // Create the options with key-value pairs and index
              countries.forEach((country, index) => {
                mtfOptions.push({
                  key: country,
                  value: shuffledCities[index],

                });
              });

              return mtfOptions;
            },
            getCorrectAnswer() {
              switch (this.questionDetails.questionType) {
                case "SINGLE_CHOICE":
                  return this.singleSelectCorrectAnswer;
                case "MULTIPLE_CHOICE":
                  return this.selectedAnswersForMultitpleTypeQuestions.join(',');

                case "FILL_IN_THE_BLANKS":
                  return 'NA';

                case "TRUE_FALSE":
                  return this.trueFalseCorrectAnswer;

                case "MATCH_THE_FOLLOWING":
                  return 'NA';

                default:
                  break;
              }
            },
            formatOptionAndAnswer(optionsWithAnswers){
                this.questionOptions = [];
                this.answers =[];

                const formattedArray = optionsWithAnswers.split(", ").map(item => {
                const [key, value] = item.split(":");
                  return { key: key.trim(), value: value.trim() };
                });
                // Split the string into individual option-answer pairs
                const pairs = formattedArray

                // Loop through the pairs to create the objects
                pairs.forEach((pair, index) => {

                  const optionKey = String.fromCharCode(65 + index); // Generates 'A', 'B', 'C', etc.

                  this.questionOptions.push({
                    optionKey: optionKey,
                    optionValue: pair.key,
                  });

                  this.answers.push({
                    optionKey: optionKey,
                    optionValue: pair.value,
                  });
                });
              },
            checkArrOptions(item = ``){
              let result = `${item}`.replace(/[^A-Za-z]/g, '');
              return Array.from(new Set(result))
            },
        },

        computed: {
          ...mapGetters({
            staticAssessmentData : 'getAssessmentData',
            questionForEdit: 'getQuestionForEdit'
          }),
          filteredMarkingTypesList() {
            if (this.questionDetails.questionType === 'SINGLE_CHOICE') {
              return this.markingTypesList;
            } else {
              // Exclude Likert Marking
              return this.markingTypesList.filter(type => type.name !== 'Likert Marking');
            }
          },
          isValid() {
            return this.getTextWithoutHTMLTags(this.editedCkeditorValue).length <= 200;
          },
          getQuestionStrand: {
            get() {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.QuestionDetails[languageKey]?.strand || '';
              }
              return '';
            },
            set(newValue) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.QuestionDetails[languageKey]) {
                  // Update the value of strand dynamically
                  this.questionDetails.QuestionDetails[languageKey].strand = newValue;
                }
              }
            }
          },
          getQuestionSubStrand: {
            // Getter: Retrieves the current value of subStrand
            get() {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.QuestionDetails[languageKey]?.subStrand || '';
              }
              return '';
            },
            // Setter: Updates the value of subStrand when the user types
            set(newValue) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.QuestionDetails[languageKey]) {
                  // Update the value of subStrand dynamically
                  this.questionDetails.QuestionDetails[languageKey].subStrand = newValue;
                }
              }
            }
          },
          getQuestionTopic: {
            // Getter: Retrieves the current value of topic
            get() {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.QuestionDetails[languageKey]?.topic || '';
              }
              return '';
            },
            // Setter: Updates the value of topic when the user types
            set(newValue) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.QuestionDetails[languageKey]) {
                  // Update the value of topic dynamically
                  this.questionDetails.QuestionDetails[languageKey].topic = newValue;
                }
              }
            }
          },
          getQuestionHint: {
            // Getter: Retrieves the current value of topic
            get() {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.QuestionDetails[languageKey]?.hint || '';
              }
              return '';
            },
            // Setter: Updates the value of topic when the user types
            set(newValue) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.QuestionDetails[languageKey]) {
                  // Update the value of topic dynamically
                  this.questionDetails.QuestionDetails[languageKey].hint = newValue;
                }
              }
            }
          },
          questionOptions: {
            // Getter: Retrieves the current question options for the selected language
            get() {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.QuestionDetails[languageKey]?.questionOptions || [];
              }
              return [];
            },
            // Setter: Updates the question options when the user adds/removes or modifies options
            set(newOptions) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.QuestionDetails[languageKey]) {
                  // Update the options dynamically
                  this.questionDetails.QuestionDetails[languageKey].questionOptions = newOptions;
                }
              }
            }
          },
          enableSave: {
          get() {
            const marksAllotted = this.questionDetails.marksAllotted ? Number(this.questionDetails.marksAllotted) || 0 : 0;
            const correctAnswer = this.questionDetails.correctAnswer;
            // Validate essential fields
            const validTopic = this.availableQuesLanguages.every(language => {
            const languageKey = language.toLowerCase();
            const topic = this.questionDetails.QuestionDetails[languageKey]?.topic || "";
            return topic && topic.trim().length > 0;
            });          

            const validQuestionStatement = this.availableQuesLanguages.every(language => {
            const languageKey = language.toLowerCase();
            const questionStatement = this.questionDetails.QuestionDetails[languageKey]?.questionStatement || "";
            return questionStatement && questionStatement.trim().length > 0;
            });
            const validQuestionsOptions = this.availableQuesLanguages.every(language => {
              const languageKey = language.toLowerCase();
              const questionOptions = this.questionDetails.QuestionDetails[languageKey]?.questionOptions || [];
              return Array.isArray(questionOptions) &&
              questionOptions.length >= 2 &&
              !questionOptions.some(option => option.optionValue === "");
            })           
            const isValidBase = correctAnswer && validTopic && validQuestionStatement && validQuestionsOptions && this.questionDetails.groupName;
        
            return !(isValidBase);
          }
          }, 
          getQuestionSubject: {
            // Getter: Retrieves the current value of topic
            get() {
              if (this.currentSelectedLanguage) {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                return this.questionDetails.subject[0] || '';
              }
              return '';
            },
            // Setter: Updates the value of topic when the user types
            set(newValue) {
              if (this.currentSelectedLanguage && typeof this.currentSelectedLanguage === 'string') {
                const languageKey = this.currentSelectedLanguage.toLowerCase();
                if (this.questionDetails.subject && this.questionDetails.subject.length > 0) {
                  // Update the value of topic dynamically
                  this.questionDetails.subject[0] = newValue;
                }
              }
            }
          },
        },
    }

</script>

<style scoped>
  .m-ckeditor {
    height: 153px;
  }
  .add-options {
    color: #1B72E8;
    cursor: pointer;
  }
  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #1B72E8;
    border-radius: 50px;
  }
  textarea {
    width: 100%;
    min-height: 73px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    resize: none;
  }

.language-chips {
  .v-chip {
    background: white !important;
  }
  .active-chip.v-chip--outlined {
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
    color: var(--blue-01) !important;
    border: 1px solid var(--blue-01);
    background: var(--gray-02) !important;
  }
}

.options-row {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 12px;
  gap: 12px; 
  max-width: 100%;
  overflow: hidden;
}

.questions-options {
  flex-grow: 1;
  max-width: 100%;
  overflow: hidden;
}

.close-icon-wrapper {
  background: #EE4D374D;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0
}

.buttons-container {
  .v-list-item__action--stack {
    flex-direction: row;
    margin: 0;
  }
}

.options-score-dialog >>> .v-overlay__scrim {
  z-index: 2100 !important; /* higher than typical dialog scrim */
}
.options-score-dialog >>> .v-dialog {
  z-index: 2200 !important; /* higher than typical dialog */
}
.options-icon{
  font-size: 24px !important;
}
.options-btn{
  height: 24px !important;
  width: 24px !important;
}
.options-attach-img{
  width: 64px;
}

</style>